import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/84450117-c1b2-4892-ad8b-d21d465ed98e";
export const REGISTER_URL = "https://a.ntrk2.com/424c321f-8013-43d4-bf4c-a286c433c01a";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://shuvowin.kzw2a.com/download?openExternalBrowser=1&id=dpub23lz8um7miv";

export * from "./codes";
export * from "./context";
